import React, { useState, useEffect } from "react";
import { Button, Form, Input, Modal, Popconfirm, Select } from "antd";

import area from "../../data/Location";
import util from "../../utils/functions/custom";
import { recordError } from "../../utils/logService";

export const AddressControl = ({
  title,
  onCancel,
  visible,
  isLocal,
  onModalSubmit,
  address = {},
}) => {
  const formItemLayout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };

  const formName = "AddressForm";
  const [form] = Form.useForm();
  const { Option } = Select;

  const [provinces, setProvince] = useState([
    ...area.provinces.sort(util.setDynamicSort("text")),
  ]);
  const [countries, setCountry] = useState([
    ...area.countryList.sort(util.setDynamicSort("text")),
  ]);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (!util.isEmpty(address)) {
      loadAddress();
    } else {
      form.resetFields();
      //Preselect South African if local
      if (isLocal) {
        const selectedCountry = countries.find(
          (record) => record.value === "South Africa"
        );
        form.setFieldsValue({ country: selectedCountry });
      }
    }
  }, [address]);

  const loadAddress = () => {
    let selectedProvince;
    let selectedCountry;

    if (isLocal) {
      selectedProvince = provinces.find(
        (record) => record.value === address.province
      );
      selectedCountry = countries.find(
        (record) => record.value === "South Africa"
      );
    } else {
      selectedProvince = address.province;
      selectedCountry = countries.find(
        (record) => record.value === address.country
      );
    }

    form.setFieldsValue({
      street: address.street,
      cityOrTown: address.cityOrTown,
      postalCode: address.postalCode,
      province: selectedProvince,
      country: selectedCountry,
    });
  };

  const onChangeProvince = (selected) => {
    const selectedProvince = provinces.filter(
      (record) => record.value === selected
    )[0];
    form.setFieldsValue({ province: selectedProvince });
  };

  const onChangeCountry = (selected) => {
    const selectedCountry = countries.filter(
      (record) => record.value === selected
    )[0];
    form.setFieldsValue({ country: selectedCountry });
  };

  const onSubmit = (values) => {
    form.resetFields();
    let id = -1;

    if (!util.isEmpty(address)) {
      id = address.id;
    }
    const _address = { ...values, id: id };
    onModalSubmit(_address);
  };

  const onPostalChange = (e) => {
    const { value } = e.target;
    form.setFieldsValue({ postalCode: util.toNumeric(value) });
  };

  const Confirm = () => {
    onCancel();
    if (util.isEmpty(address)) {
      form.resetFields();
    }
  };

  const onNameBlur = (e) => {
    const { value, name } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [name]: textValue });
  };

  const onPopCancel = () => {
    if (
      isLocal &&
      (form.getFieldValue("street") ||
        form.getFieldValue("cityOrTown") ||
        form.getFieldValue("province") ||
        form.getFieldValue("postalCode"))
    ) {
      setDisabled(false);
    } else if (
      !isLocal &&
      (form.getFieldValue("foreignaddress") || form.getFieldValue("country"))
    ) {
      setDisabled(false);
    } else {
      onCancel();
      setDisabled(true);
    }
  };

  return (
    <Modal
      title={title}
      onCancel={onCancel}
      open={visible}
      maskClosable={true}
      onOk={() =>
        form
          .validateFields()
          .then((res) => {
            form.resetFields();
            onSubmit(res);
          })
          .catch((error) =>{
            recordError(error)
          })
          
      }
      footer={[
        <div className="modal-footer-buttons">
          <Popconfirm
            key="2"
            title="Are you sure you want to cancel...you will lose all info entered?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => Confirm()}
            onCancel={onPopCancel}
            disabled={disabled}
          >
            <Button onMouseUp={() => onPopCancel()} style={{ marginLeft: 10 }}>
              Cancel
            </Button>
          </Popconfirm>
          <Button
            key="1"
            type="primary"
            htmlType="submit"
            onSubmit={onSubmit}
            form={formName}
          >
            Save
          </Button>
        </div>,
      ]}
    >
      <Form
        {...formItemLayout}
        name={formName}
        form={form}
        layout="horizontal"
        onFinish={onSubmit}
      >
        <>
          <Form.Item
            name="country"
            label="Country"
            rules={[{ required: true, message: "Please select a country" }]}
          >
            <Select onChange={onChangeCountry}>
              {countries.map((country) => (
                <Option key={country.value}>{country.text}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="street"
            label="Street Address"
            rules={[{ required: true, message: "Please enter street address" }]}
          >
            <Input name="street" onBlur={onNameBlur} />
          </Form.Item>
          <Form.Item
            name="cityOrTown"
            label="Town/City"
            rules={[{ required: true, message: "Please enter town/city" }]}
          >
            <Input name="cityOrTown" onBlur={onNameBlur} />
          </Form.Item>
          <Form.Item
            name="province"
            label="Province/State"
            rules={[
              { required: true, message: "Please select a province/state" },
            ]}
          >
            {isLocal ? (
              <Select onChange={onChangeProvince}>
                {provinces.map((province) => (
                  <Option key={province.value}>{province.text}</Option>
                ))}
              </Select>
            ) : (
              <Input
                name="province"
                onBlur={onNameBlur}
                value={form.getFieldValue("province")}
              />
            )}
          </Form.Item>

          <Form.Item
            name="postalCode"
            label="Postal Code"
            rules={[{ required: true, message: "Please enter postal code" }]}
          >
            <Input
              style={{ width: 100 }}
              minLength={4}
              maxLength={6}
              onChange={onPostalChange}
            />
          </Form.Item>
        </>
      </Form>
    </Modal>
  );
};

// export default AddressControl;
